import React, { useState, useEffect } from "react";
import { Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useLocation } from "react-router-dom";
import ViewHeader from "./ViewHeader";
import ProductViewDtls from "./ProductViewDtls";
//import ImageAttachment from "../../biztran_controls/ImageAttachment";
//import CreateAttachments from "../../crm/Activities/CreateAttachments";
//import ProductCategoryTV from "./ProductCategoryTV";
//import AddCategory from "./AddCategory";
import UseFetchData from "../../../hooks/UseFetchData";
//import ModalFrame from "../../biztran_controls/Modal_Frame";
import RelatedView from "./RelatedView";

const ProductMasterView = () => {
  const classes = useStyles();
  const [ProductName, setProductName] = useState('');
  const [ProductCat, setProductCat] = useState([]);
  const [responseGetByID, setresponseGetByID] = useState([]);
  const location = useLocation();
  const [response, fetchData] = UseFetchData();

  useEffect(() => {
    if (response.Main !== undefined) {
      setresponseGetByID(response.Main);
      setProductName(response.Main[0].ProductName);
      setProductCat(response.ProdCat);
    }
  }, [response]);

  useEffect(() => {
    getProductViewData(location.state.ProductID);
  }, []);

  const getProductViewData = (ProductID) => {
    var bodyFormData = new FormData();
    bodyFormData.append("ProductID", ProductID);
    bodyFormData.append("ProductCat1ID", "");
    bodyFormData.append("ProductCat2ID", "");
    bodyFormData.append("ProductCat3ID", "");
    bodyFormData.append("ProductCat4ID", "");
    fetchData("Product/View", bodyFormData);
  };

  return (
    <Paper>
      <ViewHeader ProductID={location.state.ProductID} 
        responseGetByID={responseGetByID} 
        getProductViewData={getProductViewData}
      />
      <div className={classes.container}>
        <div style={{ gridColumnEnd: "span 9" }}>
          <Paper style={{ border: "0.1rem solid gray"}} elevation={3}>
            <ProductViewDtls
              ProductID={location.state.ProductID}
              ProductName={ProductName}
              getProductViewData={getProductViewData}
            />
          </Paper>
        </div>
        <div style={{ gridColumnEnd: "span 3" ,boxSizing:"unset"}}>
          <RelatedView 
            ProductID={location.state.ProductID}
            ProductCat={ProductCat}
            ProductName={ProductName}
            getProductViewData={getProductViewData}
          />
        </div>
      </div>
    </Paper>
  );
};

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: theme.spacing(1),
    marginTop: 7,

  },
}));

export default ProductMasterView;
